import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-territoire',
  templateUrl: './territoire.component.html',
  styleUrls: ['./territoire.component.scss']
})
export class TerritoireComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
